import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
  reason: string;
}

export const useInvalidateAllReleasedDeclarations = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, reason }: HookProps) => {
      await request({
        path: 'idms/invalidate-all',
        method: 'POST',
        authenticate: true,
        dataObject: { reason, batchId },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declarations'] });
      toast.success('Invalidation request was sent!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending invalidation request!`);
    },
  });
};
